/**
 * global google
 */

import { Loader } from '@googlemaps/js-api-loader';
import { initializeMarkerCluster } from '../libs/maps-clustering';

let map;
let placeMarkers = [];
const allMarkers = [];
let mapPosition;
let activeInfoWindow;
const $locations_row = $('.find_us__retailers__row');
const searchZoom = $('.find_us__map .map').data('search-zoom');
const unit = $('.find_us__map .map').data('unit');
const miOrKm = $('.find_us__map .map').attr('data-mi-or-km');

const findus = {
    init: () => {
        findus.loader();
        findus.distributorAccordion();
        findus.initMap();
    },

    loader: () => {
        setTimeout(() => {
            $('.find_us__loader').fadeOut(600, function () {
                $(this).remove();
            });
        }, 1000);
    },

    distributorAccordion: () => {
        $('.page-template-template-findus dt').on('click', e => {
            e.preventDefault();

            // only show 1 expanded, close any open ones
            $('.collapse').collapse('hide');
        });
    },

    initMap () {
        this.settings = {
            mapSelector: '.map',
            mapProperties: '.map__properties',
        };
        const minZoom = $(this.settings.mapSelector).data('min-zoom');
        const maxZoom = $(this.settings.mapSelector).data('max-zoom');
        const mapStyles = $(this.settings.mapProperties).data('map-styles');

        this.mapOptions = {
            zoom: 10,
            minZoom: 10,
            maxZoom: 20,
            styles: mapStyles,
            scrollwheel: false,
            disableDefaultUI: true,
            zoomControl: true,
            mapId: '563cc0caf2497ad',
        };
        this.apiKey = `${window.__ECL_GLOBAL__.gm_api_key}`;

        const loader = new Loader({
            libraries: ['places', 'marker'],  // Ensure marker library is loaded
            apiKey: this.apiKey,
        });

        loader.load().then(
            async () => {
                try {
                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                    const geocoder = new google.maps.Geocoder();
                    $(this.settings.mapSelector).map((index, element) => {
                        const $element = $(element);

                        mapPosition = {
                            lat: parseFloat($element.data('lat')),
                            lng: parseFloat($element.data('lng')),
                        };

                        const $markers = $('.find_us__retailers .map__marker');

                        const args = this.mapOptions;
                        args.center = mapPosition;
                        args.mapTypeId = google.maps.MapTypeId.ROADMAP;
                        map = new google.maps.Map($element[0], args);

                        const icon = {
                            url: `${window.__ECL_GLOBAL__.theme_url}/img/marker.svg`,
                            scaledSize: new google.maps.Size(30, 30),
                        };

                        $markers.each(function (index) {
                            const lat = parseFloat($(this).data('lat'));
                            const lng = parseFloat($(this).data('lng'));

                            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {  // Validate lat/lng
                                const latlng = new google.maps.LatLng(lat, lng);
                                const createIconElement = (url, size) => {
                                    const iconElement = document.createElement('div');
                                    iconElement.innerHTML = `<img src="${url}" style="width: ${size.width}px; height: ${size.height}px;" alt="">`;
                                    return iconElement;
                                };
                                const marker = new AdvancedMarkerElement({
                                    position: latlng,
                                    map,
                                    content: createIconElement(icon.url, icon.scaledSize),
                                    zIndex: 100,
                                });
                                // If marker contains HTML, add it to an infoWindow
                                if ($(this).html()) {
                                    const infowindow = new google.maps.InfoWindow({
                                        content: $(this).html(),
                                    });
                                    marker.infowindow = infowindow;
                                    google.maps.event.addListener(marker, 'click', () => {
                                        if (activeInfoWindow) {
                                            activeInfoWindow.infowindow.close();
                                            activeInfoWindow = createIconElement(
                                                `${window.__ECL_GLOBAL__.theme_url}/img/marker.svg`,
                                                new google.maps.Size(30, 30)
                                            );
                                        }

                                        marker.content = createIconElement(
                                            `${window.__ECL_GLOBAL__.theme_url}/img/marker-active.svg`,
                                            new google.maps.Size(35, 35)
                                        );


                                        activeInfoWindow = marker;
                                        infowindow.open(map, marker);
                                    });


                                    google.maps.event.addListener(infowindow, 'closeclick', () => {
                                        marker.content = createIconElement(
                                            `${window.__ECL_GLOBAL__.theme_url}/img/marker.svg`,
                                            new google.maps.Size(30, 30)
                                        );
                                    });
                                }

                                allMarkers.push(marker);
                            } else {
                                console.warn(`Invalid lat/lng for marker at index ${index}: lat=${lat}, lng=${lng}`);
                            }
                        });

                        const center = mapPosition;
                        google.maps.event.addDomListener(window, 'resize', () => {
                            google.maps.event.trigger(map, 'resize');
                            map.setCenter(center);
                        });

                        // Create cluster
                        initializeMarkerCluster(map, allMarkers);

                        // Set default location to capital center
                        findus.setNewLocation(mapPosition);

                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(
                                position => {
                                    mapPosition = {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                    };
                                    findus.setNewLocation(mapPosition);
                                },
                                err => {
                                        // console.log(err);
                                }
                            );
                        }

                        const input = document.getElementById('search-address');
                        const autocomplete = new google.maps.places.Autocomplete(input);
                        autocomplete.bindTo('bounds', map);

                        $('.search-box__form').on('submit', e => {
                            e.preventDefault();
                            const inputVal = $('.search-box__form #search-address').val();

                            if (inputVal.length !== 0) {
                                geocoder.geocode(
                                    { address: inputVal },
                                    (results, status) => {
                                        if (status === 'OK') {
                                            mapPosition = {
                                                lat: results[0].geometry.location.lat(),
                                                lng: results[0].geometry.location.lng(),
                                            };
                                            findus.setNewLocation(mapPosition);
                                        } else {
                                            console.warn('Geocode was not successful for the following reason: ' + status);
                                            alert($('.find_us__map .map').data('error'));
                                        }
                                    }
                                );
                            }
                        });

                        $('body').on('click', '.retailerblock__content__button', e => {
                            const $button = $(e.target);
                            const $retailerBlock = $button.closest('.retailerblock');

                            const lat = parseFloat($retailerBlock.data('lat'));
                            const lng = parseFloat($retailerBlock.data('lng'));

                            const newLatlng = new google.maps.LatLng(lat, lng);
                            map.setZoom(maxZoom);
                            map.setCenter(newLatlng);

                            allMarkers.forEach((item, index) => {
                                if (item.position && typeof item.position.lat === 'function' && typeof item.position.lng === 'function') {
                                    const markerLat = item.position.lat();
                                    const markerLng = item.position.lng();

                                    if (markerLat === lat && markerLng === lng) {
                                        google.maps.event.trigger(item, 'click');
                                    }
                                };
                            });
                        });

                        $('body').on('click', '.find_us__map .retailerblock', function (e) {
                            e.preventDefault();
                            $(this).find('.retailerblock__content__button').click();
                        });

                        $('body').on('click', '.find_us__map .retailerblock .retailerblock__content__button', e => {
                            e.stopPropagation();
                        });

                        $('body').on(
                            'click',
                            '.find_us__map .retailerblock .retailerblock__content__phone a',
                            e => {
                                e.stopPropagation();
                            }
                        );

                        $('body').on('click', '.jsFire', e => {
                            e.preventDefault();
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(
                                    position => {
                                        mapPosition = {
                                            lat: position.coords.latitude,
                                            lng: position.coords.longitude,
                                        };
                                        findus.setNewLocation(mapPosition);
                                    },
                                    err => {
                                        console.error(err);
                                    }
                                );
                            }
                        });
                    });
                } catch (error) {
                    console.error("Error initializing the map or markers: ", error);
                }
            },
            (err) => {
                console.error("Error loading Google Maps: ", err);
            }
        );
    },

    setNewLocation: mapPosition => {
        if (!mapPosition) {
            console.error("Invalid map position:", mapPosition);
            return;
        }

        // Remove current place marker while searching for a new location
        placeMarkers.forEach((marker) => marker.setMap(null));
        placeMarkers = [];

        map.setZoom(searchZoom);
        map.setCenter(mapPosition);

        const iconElement = document.createElement('div');
        iconElement.innerHTML = `<img src="${window.__ECL_GLOBAL__.theme_url}/img/marker.svg" style="width: 30px; height: 30px;" alt="">`;

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: mapPosition,
            map: map,
            content: iconElement,
            zIndex: 10,
        });
        placeMarkers.push(marker);

        let distances = [];
        let closest = -1;
        const $nearest_row = $('.find_us__nearest__row');

        // Calculate distances
        allMarkers.forEach((marker, index) => {
            const {position} = marker;

            // Check if position has Fg and Gg properties (new format)
            let lat, lng;
            if (position && typeof position.lat === 'function' && typeof position.lng === 'function') {
                // It's a LatLng object
                lat = position.lat();
                lng = position.lng();
            } else if (position && position.lat !== undefined && position.lng !== undefined) {
                lat = position.lat
                lng = position.lng;
            } else {
                console.warn(`Invalid position for marker at index ${index}:`, position);
                return; // Skip this marker
            }
            const R = 3958.8; // Radius of the Earth in miles
            const rlat1 = lat * (Math.PI / 180); // Convert degrees to radians
            const rlat2 = mapPosition.lat * (Math.PI / 180); // Convert degrees to radians
            const difflat = rlat2 - rlat1; // Radian difference (latitudes)
            const difflon = (mapPosition.lng - lng) * (Math.PI / 180); // Radian difference (longitudes)

            const d = 2 * R * Math.asin(Math.sqrt(
                Math.sin(difflat / 2) * Math.sin(difflat / 2) +
                Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
            ));
            if (Number.isNaN(d)) {
                return; // Skip this marker
            }

            if (!isNaN(d)) {
                if (miOrKm === 'km') {
                    const kmPrecise = d * 1.60934;
                    const kmDisplay = kmPrecise.toFixed(1);
                    $locations_row.find('.column:eq(' + index + ')')
                        .find('.marker__distance').html(kmDisplay + '&nbsp;' + unit);
                } else {
                    $locations_row.find('.column:eq(' + index + ')')
                        .find('.marker__distance').html(d.toFixed(1) + '&nbsp;' + unit);
                }

                distances.push({
                    distance: d,
                    template: '<div class="column">' + $locations_row.find('.column:eq(' + index + ')').html() + '</div>',
                });

                if (closest === -1 || d < distances[closest].distance) {
                    closest = index;
                }
            }
        });

        // Sort distances
        distances.sort((a, b) => a.distance - b.distance);
        // Add distances to the nearest location table
        $nearest_row.html('');
        distances.forEach((item) => {
            if (item.distance <= 30) {
                $nearest_row.append(item.template);
            }
        });
    }

};

$(document).ready(() => {
    findus.init();
});
